import $ from 'jquery';
import _ from 'underscore';
import {isPresent} from "../../utilities/general";
import { isNull } from 'util';
import render from '../../utilities/render';
const productRowReviewTabHtml = require('./html/productOnReviewTab.html');
const unitPillHtml = require('./html/unitPill.html');
const bundleChildBodyOnReviewTabHtml = require('./html/bundleChildBodyOnReviewTab.html');

const elementsMap = {
    allDestinationAreas: ".review-tab-customer-group",

    palletMessage: ".pallet-message",

    orderReferenceNumberOuterReviewTab: ".review-tab-order-reference-number-outer",
    orderReferenceNumber: "#orderReferenceNumber",
    orderReferenceNumberReviewTab: ".review-tab-order-reference-number-val",

    dropShipSectionDiv:".review-tab-dropship-section",
    dropShipSectionVal:".review-tab-dropship-val",
    dropshipFlag:"#dropShipFlag",

    reviewTabOrderTypeVal: ".review-tab-order-type-val",
    reviewTabOrderFulfillmentCenterVal: ".review-tab-order-fulfillment-center-val",
    destinationTabOrderType: "#destination-tab-order-type-select",
    destinationTabOrderFulfillmentCenter: "#order-fulfillment-center",

    shippingTypeOuterReviewTab: ".review-tab-shipping-type-outer",
    shippingTypeSelect: "#shipping-tab-shipping-type-select",
    shippingTypeReviewTab: ".review-tab-shipping-type-val",

    // LTL ONLY
    // allow for 'other' box
    facilityOuterReviewTab: ".review-tab-facility-outer",
    businessName: "#destination-tab-business-name",
    retailerType: "#destinationTab-typeahead",
    facilityReviewTab: ".review-tab-facility-val",

    // BOTH
    customerEmailOuterReviewTab: ".review-tab-shipping-email-outer",
    customerEmailBtoB: "#destination-tab-btob-customerEmail",
    customerEmail: "#destination-tab-customerEmail",
    customerEmailReviewTab: ".review-tab-shipping-email-val",

    // PARCEL ONLY
    customerNameOuterReviewTab: ".review-tab-customer-name-outer" ,
    customerName: "#customerName",
    customerNameReviewTab: ".review-tab-customer-name-val",

    // LTL ONLY
    contactNameOuterReviewTab: ".review-tab-contact-name-outer" ,
    contactName: "#destination-tab-contactName",
    contactNameReviewTab: ".review-tab-contact-name-val",


    // PARCEL ONLY
    companyNameOuterReviewTab: ".review-tab-company-outer",
    companyName: "#company",
    companyNameReviewTab: ".review-tab-company-val",


    // LTL ONLY
    destinationNameOuterReveiewTab: ".review-tab-destination-name-outer",
    destinationName: "#destination-tab-destination-name",
    destinationNameReviewTab: ".review-tab-destination-name-val",

    // BOTH
    sendTrackingInfoOuterReviewTab: ".review-tab-notifiction-email-outer",
    sendTrackingInfo: "#destination-tab-sendTrackingInfo",
    sendTrackingInfoBtoB: "#destination-tab-btob-sendTrackingInfo",
    sendTrackingInfoReviewTab: ".review-tab-shipping-notifiction-email-val",

    // BOTH
    customerPhoneNumberReviewTab: ".review-tab-phone-number-val",
    customerPhoneNumber: "#destination-tab-customerPhoneNumber",
    customerPhoneNumberBtoB: "#destination-tab-btob-customerPhoneNumber",
    customerCountryPhoneCode: "#destination-tab-country-phone-code",
    customerCountryPhoneCodeBtoB:"#destination-tab-b2b-country-phone-code",

    // BOTH
    address1: "#destination-tab-address1",
    address2: "#destination-tab-address2",
    city: "#destination-tab-city",
    state: "#destination-tab-state",
    stateOther: "#destination-tab-stateText",
    zip: "#destination-tab-zipCode",
    country: "#destination-tab-country",
    addressReviewTab: ".review-tab-address-val",
    addressOuterReviewTab: ".review-tab-address-outer",
    phoneNumberReviewTab: ".review-tab-phone-number-outer",

    shippingReleaseReviewTab: ".review-tab-order-release-val",
    shippingRelease: "#shipping-tab-order-release-type",

    shippingReleaseDateReviewTab: ".review-tab-order-release-date-val",
    shippingReleaseDate: "#scheduleReleaseDate",
    shippingDateAndTime:"#standardDateAndTime",

    shippingMethodReviewTab: ".review-tab-shipping-method-val",
    shippingTabUsa: "#shipping-tab-shipping-method-with-usa",
    shippingTabCanada: "#shipping-tab-shipping-method-with-canada",
    shippingTabOther: "#shipping-tab-shipping-method-other",
    shippingTabAkHw: "#shipping-tab-shipping-method-with-ak-hw",
    productsTableProductsTab: "#product-bundle-row",
    productsTableBodyReviewTab: ".review-tab-products-table-body",
    sectionTitlesReviewTab: ".section-step-title-inner",
    reviewTabFreightCostsOuter: ".review-tab-freight-costs-outer",
    reviewTabFreightCosts: ".review-tab-freight-costs-val",
    freightCosts: "#freight-costs",
    reviewTabInsuranceCostsOuter: ".review-tab-insurance-costs-outer",
    reviewTabInsuranceCosts: ".review-tab-insurance-costs-val",
    insuranceCosts: "#insurance-costs",
    reviewTabDutiesTaxesOuter: ".review-tab-duties-taxes-outer",
    reviewTabDutiesTaxes: ".review-tab-duties-taxes-val",
    dutiesTaxes: "#duties-taxes",

    shippingTabIsAGiftCheckbox: "#gift-checkbox",
    ordExcludeCollateralCheckbox: "#exclude-collateral",
    ordBulkPackagingCheckbox: "#bulk-packaging",
    shippingTabGiftTextArea: "#gift-textarea",
    reviewTabIsAGiftVal: ".review-tab-order-is-a-gift-val",
    reviewTabGiftMessageVal: ".review-tab-gift-message-val",
    reviewTabOrderIsAGiftOuter: ".review-tab-order-is-a-gift-outer",
    reviewTabGiftMessageOuter: ".review-tab-gift-message-outer",
    createOrderSubmitBtn: ".create-button",
    giftPackagingValOn: ".gift-packaging-val-on",
    giftPackagingValOff: ".gift-packaging-val-off",
    reviewOrdBulkPackagingValOn: ".review-ord-bulk-packaging-val-on",
    reviewOrdBulkPackagingValOff: ".review-ord-bulk-packaging-val-off",
    reviewOrdExcludeCollateralValOn: ".review-ord-ex-coll-val-on",
    reviewOrdExcludeCollateralValOff: ".review-ord-ex-coll-val-off",
    reviewOrdBulkPackagingMsg: ".review-ord-bulk-packaging-msg",
    reviewOrdExcludeCollateralMsg: ".review-ord-ex-coll-val-msg",

    shippingTabServiceLevelUsa: "#shipping-tab-shipping-service-level-with-usa",
    reviewTabServiceLevelUsa: ".review-tab-shipping-method-with-usa-rate-shopping",
    reviewTabServiceLevelUsaWrapper : ".review-tab-shipping-method-with-usa-rate-shopping-wrapper",

    shippingTabEstimatedDeliveryDate: ".estimated-delivery-date-picker",
    reviewTabEstimatedDeliveryDate: ".review-tab-estimated-delivery-date",
    reviewTabEstimatedDeliveryDateWrapper: ".review-tab-estimated-delivery-date-wrapper",

    shippingTabFedExShippingMethodValueCheck:"#fedex-shipping-method-btn-value-check",
    shippingTabServiceLevelsValueCheck:"#service-levels-btn-value-check",

    reviewTabShippingMethodWrapper: ".review-tab-shipping-method-with-usa-wrapper",
    reviewTabServiceLevelWrapper: ".review-tab-shipping-method-with-usa-rate-shopping-wrapper",

    reviewTabShippingMethod:".review-tab-shipping-method-with-usa",

    //7775 changes for Accessorial declarations
    reviewOrdSignatureOptionSelect:"#signature-options-select",
    reviewOrdSignatureOptionVal:".review-tab-signature-options-val",
    reviewOrdSaturdayDeliveryCheckebox:"#saturday-delivery-checkbox",
    reviewOrdSaturdayDeliveryVal:".review-tab-sat-delivery-val",
    reviewOrdSaturdayDeliveryLabel:".review-tab-satural-label",
    reviewOrdAccessorialDiv:".review-accessorial-section",
    declaredValueCheckbox:"#declared-value-checkbox",
    reviewDeclaredValueDiv:"#review-tab-dvl-div",
    reviewDeclaredValue:"#review-tab-dvl-value",

    productsSectionOnReviewTab:".product-row-on-review-tab" ,
    productRowOnReviewTab: ".review-tab-products-row",

    childProductRowOnReviewTab:"review-tab-child-products-row",
    
    retainChannelShipmentMethodSwitch:"#channelShippingMethodCheck",
    channelShippingMethod: "#channel-shipping-method"
   
  };

  const productItemsMap = {
    quantityInput: ".products-tab-quantity-input",
    name: ".products-tab-product-name",
    body: ".products-tab-product-description",
    available: ".products-tab-parent-avail-units",
    productUom: ".products-tab-uom",
    availqty: ".products-tab-available-qty"
  };

  const childProductMap = {
    name: ".products-tab-child-product-name",
    body: ".products-tab-child-product-description",
    available: ".products-tab-child-available-units",
    availqty: ".products-tab-available-qty"
  };

export default function ReviewTab(wizard){
    const self = this;
    const wizardElement = wizard.getWizardElement();
    const els = {};

    self.didNavigateToForm = function(){
        fillElementsWithVals();
        fillProductsInReviewTab();
    };

    self.init = function(){
        setElements();
        bindElements();
    };

    function bindElements(){
        els.sectionTitlesReviewTab.bind('click', function(){
          const form = wizardElement.find($(this).data("target-form"));
          wizard.gotToForm(form);
        });
    }

    function setElementsFromScope(targetObj, elementsDict, scope){
        _(elementsDict).each((v, k)=>{
          targetObj[k] = scope.find(v);
        });
    }

    function setElements(){
        setElementsFromScope(els, elementsMap, wizardElement);
        els.giftPackagingValOn.hide();
        els.giftPackagingValOff.hide();
        els.reviewOrdBulkPackagingValOn.hide();
        els.reviewOrdBulkPackagingValOff.hide();
        els.reviewOrdExcludeCollateralValOn.hide();
        els.reviewOrdExcludeCollateralValOff.hide();
        els.reviewOrdBulkPackagingMsg.hide();
        els.reviewOrdExcludeCollateralMsg.hide();
        
        
    }

    function fillProductsInReviewTab(){
        els.productsSectionOnReviewTab.text("");
        const products = els.productsTableProductsTab.find('.product-data-row');
        products.each(function(){
            const product = $(this);
            const productDetailEls = {};
            const bundleIcon = '<i class="fa fa-cubes q-icon-marg-left" aria-hidden="true"></i>';
            setElementsFromScope(productDetailEls, productItemsMap, product);

            const childProducts = product.find(".bundle-child-product-row");
            if(childProducts && childProducts.length) {
                let childProductsRows="";
                childProducts.each(function() {
                    const childProduct = $(this);
                    const childProductEls = {};
                    setElementsFromScope(childProductEls, childProductMap, childProduct);
                    if(childProductsRows==""){
                        childProductsRows = fillChildProducts(childProductEls);
                    }else{
                        childProductsRows = childProductsRows + fillChildProducts(childProductEls);
                    }

                  });

                  fillProductInReviewTab(productDetailEls, bundleIcon, childProductsRows);
            }else{
                fillProductInReviewTab(productDetailEls, "", "");
            }


        });
    }

    function fillProductInReviewTab(pEls, bundleIcon, childProducts){
        const productRow = render(productRowReviewTabHtml,{
            orderedQty : renderOrderQty(pEls.quantityInput.val(), pEls.productUom.find(":selected").text()),
            unitOfMeasure: renderUnitsOfMeasureQty(pEls.productUom.find(":selected").text()),
            productId : pEls.name.text(),
            productDescription : pEls.body.text(),
            productUnitsAvail:   renderUnitPill(pEls.availqty.val(),pEls.productUom.find(":selected").val()),
            bundleIcon: bundleIcon,
            children : childProducts
        });
        els.productsSectionOnReviewTab.append(productRow);
    }

    function renderOrderQty(orderQty, orderUom){
      if(orderQty == "1"){
        if(orderUom.indexOf("Pallet") != -1){
          return orderQty + " " + "Pallet";
        }else if(orderUom.indexOf("Case") != -1){
          return orderQty + " " + "Case";
        }else if(orderUom.indexOf("Unit") != -1){
          return orderQty + " " + "Unit";
        }
     }else{
      if(orderUom.indexOf("Pallet") != -1){
        return orderQty + " " + "Pallets";
      }else if(orderUom.indexOf("Case") != -1){
        return orderQty + " " + "Cases";
      }else if(orderUom.indexOf("Unit") != -1){
        return orderQty + " " + "Units";
      }
    }
  }


  function renderUnitsOfMeasureQty(orderUom){
    let unitsPerUom=" ";
    if(orderUom.indexOf("Units") == -1){
      let uomqtyBegin = orderUom.indexOf("(");
      let uomqtyEnd = orderUom.indexOf(")");
      unitsPerUom = orderUom.substring(uomqtyBegin, uomqtyEnd+1);
    }
    return unitsPerUom;
  }


    function fillChildProducts(pEls) {
        const childProducts = render(bundleChildBodyOnReviewTabHtml,{
          productSku:   pEls.name.text(),
          prodDesc: pEls.body.text(),
          productUnitsAvail:   renderUnitPill(pEls.availqty.val(),"Units")
        });

        return childProducts;
      }

    function renderUnitPill(unit, measure){
        let pillClass = unit > 0 ? 'q-pill-white-and-grey':'q-pill-red';
        return render(unitPillHtml, {
          pillClass,
          unit,
          measure
        });
      }

    function fillElementsWithVals(){
        hideAllDesinationAreas();
        fillGlobal();
        if(isB2B()){
          fillB2B();
        }
        else{
         fillB2C();
        }

        fillShippingAreas();
    }

    function hideAllDesinationAreas(){
        hide(els.allDestinationAreas);
      }

      function hide(el){
        el.css({display:"none"});
      }

      function show(el){
        el.css({display:"block"});
      }

      function showHideDropFlag(cotCode){
        const consolidatedOrderTypeList = els.destinationTabOrderType.data("consolidated-order-type-list");
        const groupedOrderTypeList = _.groupBy(consolidatedOrderTypeList, 'ortTypeCode')
        const orderTypeList = groupedOrderTypeList[cotCode] || []

        const found = _.findIndex(orderTypeList, (value) => {
          return !isNull(value.ortDropShip)
        })

        els.dropShipSectionDiv.addClass('hidden');
        if (found >= 0) {
          els.dropShipSectionDiv.removeClass('hidden');
          const dropShipFlagVal = els.dropshipFlag.is(":checked");
          if(dropShipFlagVal){
             els.dropShipSectionVal.text("Yes");
             els.dropshipFlag.attr("value","true");
           }else{
             els.dropShipSectionVal.text("No");
             els.dropshipFlag.attr("value","false")
           }
        }
      }

      function fillGlobal(){
        els.orderReferenceNumberReviewTab.text(els.orderReferenceNumber.val());
        els.shippingTypeReviewTab.text(selectShippingType(els.shippingTypeSelect));
        els.customerEmailReviewTab.text(getCustomerEmail());
        els.sendTrackingInfoReviewTab.text(trackingInfoBoolToHtml());
        els.addressReviewTab.text(addressFormatted());
        els.customerPhoneNumberReviewTab.text(getPhoneNumber());
        els.reviewTabOrderTypeVal.text($("#destination-tab-order-type-select option:selected").text());
        showHideDropFlag(els.destinationTabOrderType.val());

        let reviewTabOrderFulfillmentCenterVar = $('#order-fulfillment-center :selected').text();
        //7775  changes for Accessorial START
        const ordSignatureOpt=$("#signature-options-select option:selected").text();
        //If accessorial values are not selected or are disabled,do not show accessorial section on the review tab
        if((ordSignatureOpt == 'Select signature option' || ordSignatureOpt == '')
         &&  (!els.reviewOrdSaturdayDeliveryCheckebox.is(":checked"))
         && (!els.declaredValueCheckbox.is(":checked"))) {
          els.reviewOrdAccessorialDiv.hide();
        } else {
          els.reviewOrdAccessorialDiv.show();
        }

        if(ordSignatureOpt == 'Select signature option' || ordSignatureOpt == '') {
          els.reviewOrdSignatureOptionVal.text("");
        } else {
          els.reviewOrdSignatureOptionVal.text(ordSignatureOpt);
        }
        if(els.declaredValueCheckbox.is(":checked")) {
          els.reviewDeclaredValueDiv.show();
          els.reviewDeclaredValue.text("Yes");
        } else {
          els.reviewDeclaredValueDiv.hide();
          els.reviewDeclaredValue.text("");
        }
        if(els.reviewOrdSaturdayDeliveryCheckebox.is(":checked")) {
          els.reviewOrdSaturdayDeliveryLabel.show();
          els.reviewOrdSaturdayDeliveryVal.text("Yes");
        } else {
          els.reviewOrdSaturdayDeliveryLabel.hide();
          els.reviewOrdSaturdayDeliveryVal.text("");
        }
      
        //7775 changes for Accessorial END

        if(reviewTabOrderFulfillmentCenterVar === '') {
          els.reviewTabOrderFulfillmentCenterVal.text('Automated Fulfillment');
        } else {
          els.reviewTabOrderFulfillmentCenterVal.text('Force Fulfill ('+$('#order-fulfillment-center :selected').text()+')');
        }

        const showable = combineElements([
          els.shippingTypeOuterReviewTab,
          els.orderReferenceNumberOuterReviewTab,
          els.customerEmailOuterReviewTab,
          els.sendTrackingInfoOuterReviewTab,
          els.addressOuterReviewTab,
          els.phoneNumberReviewTab
        ]);
        show(showable);
      }

      function combineElements(arr){
        let output = $();
        _(arr).each((el)=>{
          output = output.add($(el));
        });
        return output;
      }

      function selectVal(el){
        let val = el.val();
        if(val === "-1"){
          val = "";
        }
        return val;
      }

      function selectShippingType(el) {
        let val = el.find(":selected").text();
        if(val === "-1"){
          val = "";
        }
        return val;
      }

      function fillB2B(){
        els.facilityReviewTab.text($("#destinationTab-typeahead option:selected").text());
        els.contactNameReviewTab.text(els.contactName.val());
        els.destinationNameReviewTab.text(els.destinationName.val());

        const showable = combineElements([
          els.facilityOuterReviewTab,
          els.contactNameOuterReviewTab,
          els.destinationNameOuterReveiewTab
        ]);

        show(showable);
      }



      function fillB2C(){
        els.customerNameReviewTab.text(els.customerName.val());
        els.companyNameReviewTab.text(els.companyName.val());

        const showable = combineElements([
          els.customerNameOuterReviewTab,
          els.companyNameOuterReviewTab
        ]);
        show(showable);
      }

      function fillShippingAreas(){
        hide(els.palletMessage);
        hide(els.reviewTabGiftMessageOuter);
        hideCostInfo();
        const isAGiftChecked = els.shippingTabIsAGiftCheckbox.is(":checked");
        const isAExCollChecked = els.ordExcludeCollateralCheckbox.is(":checked");
        const isABulkPackChecked = els.ordBulkPackagingCheckbox.is(":checked");
        const giftMesssage = els.shippingTabGiftTextArea.val();
        const shippingReleaseVal = selectVal(els.shippingRelease);
        els.shippingReleaseReviewTab.text(shippingReleaseVal);

        let shippingReleaseDateVal = "";

        if(shippingReleaseVal === "Scheduled Release"){
          shippingReleaseDateVal = els.shippingDateAndTime.val() + ' ET';
        }

        els.shippingReleaseDateReviewTab.text(shippingReleaseDateVal);

        let shippingMethodVal = "";
        let shippingServiceLevelVal="";
        let estimatedDlvyDateVal="";
        let shippingTabEstimatedDeliveryDateVal="";
        let shippingTabFedExShippingMethodValueCheckVal="";
        let shippingTabServiceLevelsValueCheckVal="";
        if(!isLTL()){
          if(isUsa()){
            if(isAkHw()){
              shippingMethodVal = els.shippingTabAkHw.val();
            }
            else{
              shippingMethodVal = els.shippingTabUsa.val();
              shippingServiceLevelVal = els.shippingTabServiceLevelUsa.find('option:selected').text();
              shippingTabEstimatedDeliveryDateVal = els.shippingTabEstimatedDeliveryDate.val();
              shippingTabFedExShippingMethodValueCheckVal=els.shippingTabFedExShippingMethodValueCheck.val();
              shippingTabServiceLevelsValueCheckVal=els.shippingTabServiceLevelsValueCheck.val();

              if(shippingTabFedExShippingMethodValueCheckVal=="true"){
                els.reviewTabShippingMethod.text(els.shippingTabUsa.find('option:selected').text());
                els.reviewTabEstimatedDeliveryDateWrapper.hide();
                els.reviewTabServiceLevelUsaWrapper.hide();
                els.reviewTabShippingMethodWrapper.show();
              }

              if(shippingTabServiceLevelsValueCheckVal=="true"){
                els.reviewTabShippingMethod.text(shippingServiceLevelVal);
                els.reviewTabEstimatedDeliveryDateWrapper.show();
                els.reviewTabServiceLevelUsaWrapper.show();
                els.reviewTabServiceLevelUsa.text(shippingServiceLevelVal);
                els.reviewTabEstimatedDeliveryDate.text(shippingTabEstimatedDeliveryDateVal);
                els.reviewTabShippingMethodWrapper.hide();
              }
            }
          }else if(isCanada()){
              shippingMethodVal = els.shippingTabCanada.val();
              // hide rating and estimate delivery date for international orders
              els.reviewTabShippingMethod.text(shippingMethodVal);
              els.reviewTabServiceLevelUsaWrapper.hide();
              els.reviewTabEstimatedDeliveryDateWrapper.hide();
                  showCostInfo();
          }else{
              shippingMethodVal = els.shippingTabOther.val();
              // hide rating and estimate delivery date for international orders
              els.reviewTabShippingMethod.text(shippingMethodVal);
              els.reviewTabServiceLevelUsaWrapper.hide();
              els.reviewTabEstimatedDeliveryDateWrapper.hide();
                  showCostInfo();
          }
        }
        else{
          shippingMethodVal = "LTL";
          show(els.palletMessage);
          els.reviewTabEstimatedDeliveryDateWrapper.hide();
          els.reviewTabShippingMethodWrapper.hide();
          els.reviewTabServiceLevelUsaWrapper.hide();
        }

        //If the Channel order retain flag is selected, set the value from the text box 
        if(els.retainChannelShipmentMethodSwitch.is(":checked") ) {
          els.reviewTabShippingMethod.text(els.channelShippingMethod.val());
          els.reviewTabServiceLevelUsaWrapper.hide();
          els.reviewTabEstimatedDeliveryDateWrapper.hide();
        } 

        // copy gift checkbox value to review tab
        if(isPresent(giftMesssage)){
          els.reviewTabGiftMessageVal.text(giftMesssage);
        }

        // copy Bulk Packaging checkbox value to review tab
        if(isABulkPackChecked){
          els.reviewOrdBulkPackagingValOn.show();
          els.reviewOrdBulkPackagingValOff.hide();
          els.reviewOrdBulkPackagingMsg.show();
        }else{
          els.reviewOrdBulkPackagingValOn.hide();
          els.reviewOrdBulkPackagingValOff.show();
          els.reviewOrdBulkPackagingMsg.hide();
        }

        // copy Exclude Collateral checkbox value to review tab
        if(isAExCollChecked){
          els.reviewOrdExcludeCollateralValOn.show();
          els.reviewOrdExcludeCollateralValOff.hide();
          els.reviewOrdExcludeCollateralMsg.show();
        }else{
          els.reviewOrdExcludeCollateralValOn.hide();
          els.reviewOrdExcludeCollateralValOff.show();
          els.reviewOrdExcludeCollateralMsg.hide();
        }
        els.shippingMethodReviewTab.text(shippingMethodVal);
        els.reviewTabServiceLevelUsa.text(shippingServiceLevelVal);
        els.reviewTabEstimatedDeliveryDate.text(shippingTabEstimatedDeliveryDateVal);
      }

      function showCostInfo(){
        els.reviewTabFreightCosts.text(els.freightCosts.val());
        els.reviewTabInsuranceCosts.text(els.insuranceCosts.val());
        els.reviewTabDutiesTaxes.text(els.dutiesTaxes.val());

        const showable = combineElements([
          els.reviewTabFreightCostsOuter,
          els.reviewTabInsuranceCostsOuter,
          els.reviewTabDutiesTaxesOuter
        ]);
        show(showable);
      }

      function hideCostInfo(){
        const hideable = combineElements([
          els.reviewTabFreightCostsOuter,
          els.reviewTabInsuranceCostsOuter,
          els.reviewTabDutiesTaxesOuter
        ]);
        hide(hideable);
      }

      function trackingInfoBoolToHtml(){
        let checked =false;
        if(isB2B()){
          checked = els.sendTrackingInfoBtoB.is(":checked");
        }else{
          checked = els.sendTrackingInfo.is(":checked");
        }

        if(checked){
          return "Yes";
        }
        else{
          return "No";
        }
      }

      function addressFormatted(){
        const output = `${els.address1.val()}
          ${els.address2.val()}
          ${els.city.val()},
          ${els.state.val()== null ? '': els.state.val()}
          ${els.zip.val()}
          ${els.country.find(":selected").text()}`
          .replace(/ +(?= )/g,'');
        return output;
      }

      function getPhoneNumber()
      {
         let phoneNumber =  "";
         if(isB2B())
         {
             phoneNumber = els.customerCountryPhoneCodeBtoB.val() + " " + els.customerPhoneNumberBtoB.val();
         }
         else{
              phoneNumber = els.customerCountryPhoneCode.val() + " " + els.customerPhoneNumber.val();
         }
        return phoneNumber;
      }

      function getCustomerEmail()
      {
       let customerEmail =  "";
       if(isB2B())
       {
         customerEmail = els.customerEmailBtoB.val();
       }
       else{
          customerEmail = els.customerEmail.val();
       }
      return customerEmail;
      }

      function isB2C(){
        return !!(els.shippingTypeSelect.val() === "B2C");
      }

      function isLTL(){
        return !!(els.shippingTypeSelect.val() === "LTL");
      }

      function isB2B(){
        return !!(els.destinationTabOrderType.val() === "B2B");
      }

      function isUsa(){
        const countryVal = els.country.val();

        return countryVal === "1";
      }

      function isCanada(){
        const countryVal = els.country.val();

        return countryVal === "2";
      }

      function isAkHw(){
        const stateVal = els.state.val();
        return stateVal === "HI" || stateVal === "AK";
      }

}



// WEBPACK FOOTER //
// ./src/pages/order/ReviewTab.js